/**
 * A WhatsApp number in international form, digits only (`96550001234`, ADR-0138); a Kuwaiti
 * local number (8 digits) gets 965. Null when the value is not a phone number.
 */
export function normalizeWhatsAppNumber(value: string): string | null {
  const digits = value.replace(/[\s\-().]/g, '').replace(/^(\+|00)/, '');
  if (!/^\d+$/.test(digits)) return null;
  const full = digits.length === 8 ? `965${digits}` : digits;
  return /^[1-9]\d{9,14}$/.test(full) ? full : null;
}
